export const APPROVAL_NOTE_FORM_CONFIG = [
  {
    name: 'note',
    label: 'Reason',
    type: 'textArea',
    isRequired: false,
    placeholder: 'Add a reason',
  },
];

